import { FEATURE_REMINDER_SCREENS } from '../constants';
import useFeatureReminderModal from '../hooks/useFeatureReminder';

const DashboardFeatureReminders = () => {
  const { showFeatureReminderModal } = useFeatureReminderModal({
    screenName: FEATURE_REMINDER_SCREENS.DASHBOARD,
    noOfTimesToShowFeatureReminder: 1
  });

  return showFeatureReminderModal();
};

export default DashboardFeatureReminders;
